module.exports = __webpack_public_path__ + "static/digicit-a8276457c2a9734613252d55e6659f21.jpg";